import React from 'react';
import PropTypes from 'prop-types';

import './sass/env-badge.scss';

const EnvBadge = ({ isLocalhost }) => (
  <div className="env-badge">
    {isLocalhost ? 'LOCALHOST' : 'DEVELOPMENT'}
  </div>
);

EnvBadge.propTypes = {
  isLocalhost: PropTypes.bool,
};

EnvBadge.defaultProps = {
  isLocalhost: false,
};

export default EnvBadge;
